/**
 * A policy review the consumer bought, reachable from Your Plan. Policy reviews are paid for
 * separately from self-funding, so they stay available whatever the self-funding access.
 */
import { Button } from '@design-system';
import { useConsumerFlow } from '../hooks/use-consumer-flow';

export function PolicyReviewLink({
  clientId,
  hasPolicyReview,
}: {
  clientId: string;
  hasPolicyReview: boolean;
}) {
  const { goTo } = useConsumerFlow(clientId);
  if (!hasPolicyReview) return null;

  return (
    <section
      className="flex flex-wrap items-center justify-between gap-2"
      data-testid="your-policy-review"
    >
      <h2 className="text-lg font-semibold text-gray-950">Your policy review</h2>
      <Button
        variant="outline"
        size="sm"
        onClick={() => goTo('review-status')}
      >
        See your policy review
      </Button>
    </section>
  );
}
